import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import * as Yup from "yup";
import { forgotPassword, login } from "../../actions/authAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import TextError from "../../components/WraapperComponent/TextError";

const VerifyPassword = () => {
  const initialValues = {
    password: "",
    confirmPassword: "",
  };
  const { userName, token } = useParams();
  const validationSchema = Yup.object({
    password: Yup.string()
      .min(8, "Password must be at least 8 characters long.")
      .max(64, "Password cannot exceed 64 characters.")
      .matches(
        /^(?!.*(.)\1{2})/,
        "Password should not contain 3 or more consecutive repeated characters."
      )
      .required("This field is required"),
    confirmPassword: Yup.string()
      .nullable()
      .oneOf([Yup.ref("password"), null], "Confirm password do not matched")
      .required("This field is required"),
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      user_name: decodeURIComponent(userName),
      verification_code: token,
      action: "verifyPasswordRequest",
    };
    dispatch(
      forgotPassword(
        {
          params,
        },
        () => {
          setIsValid(true);
        }
      )
    );
  }, []);

  const onSubmit = (values) => {
    const params = {
      user_password_repeat: values.confirmPassword,
      user_password_new: values.password,
      user_name: decodeURIComponent(userName),
      user_password_reset_hash: token,
      action: "setNewPassword",
    };
    dispatch(
      forgotPassword(
        {
          params,
        },
        () => {
          const params = {
            username: decodeURIComponent(userName),
            password: values.password,
          };
          dispatch(
            login({
              params,
            })
          );
        }
      )
    );
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Set new password</h2>
      <p className="page-desc">
        (please note: using a long sentence as a password is much safer than
        something like "!c00lPa$$w0rd")
      </p>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            <Form>
              <FormikControl
                control="input"
                type={showPassword ? "text" : "password"}
                label="Password *"
                showPassword={showPassword}
                setShowPassword={setShowPassword}
                placeholder="Credentials"
                name="password"
                hasError={formik.errors.password && formik.touched.password}
              />
              <ErrorMessage name="password" component={TextError} />
              <FormikControl
                control="input"
                type={showConfirmPassword ? "text" : "password"}
                label="Confirm Password *"
                showPassword={showConfirmPassword}
                setShowPassword={setShowConfirmPassword}
                placeholder="Credentials"
                name="confirmPassword"
                hasError={
                  formik.errors.confirmPassword &&
                  formik.touched.confirmPassword
                }
              />
              <ErrorMessage name="confirmPassword" component={TextError} />
              <div className="submit-section">
                <button
                  className="btn-orange"
                  type="submit"
                  disabled={!formik.isValid}
                >
                  Submit new Password
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
      <p className="text ">
        <span>
          <Link className="link-orange" to="/login">
            Back to Login Page
          </Link>
        </span>
      </p>
    </div>
  );
};

export default VerifyPassword;
